import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import IconButton from "shared/react_components/IconButton";

import { navColumn, expandButton, navButtonActive, navButtonInactive } from "../styles/CallDetailsNavColumn.module.scss";

const CallDetailsNavColumn = ({ cuid, currentPane, enableCallCommenting, enableCallScoring, transcriptPresent, transcriptExpanded, onTranscriptExpandedChange }) => {
  const navButtonClassname = paneName => currentPane === paneName ? navButtonActive : navButtonInactive;
  const collapseTranscript = () => {
    if (transcriptExpanded) {
      onTranscriptExpandedChange(!transcriptExpanded);
    }
  };

  const navButton = (icon, paneName, linkTo, toolTipText) => (
    <IconButton
      className={navButtonClassname(paneName)}
      icon={icon}
      component={Link}
      to={location => ({ ...location, pathname: linkTo })}
      data-test-id={`${paneName}-button`}
      onClick={collapseTranscript}
      tooltipText={toolTipText}
      tooltipPlacement="left"
    />
  );

  return (
    <div className={navColumn}>
      {transcriptPresent &&
        <IconButton
          className={expandButton}
          icon={transcriptExpanded ? "arrow_backward" : "arrow_forward"}
          tooltipText={transcriptExpanded ? "Collapse Transcript" : "Expand Transcript"}
          onClick={() => onTranscriptExpandedChange(!transcriptExpanded)}
          tooltipPlacement="left"
          data-test-id="expand-collapse-button"
        />
      }
      {(enableCallCommenting || enableCallScoring) && navButton("call", "calls", `/${cuid}`, "Call Details")}
      {enableCallCommenting && navButton("comment", "comments", `/${cuid}/comments`, "Comments")}
      {enableCallScoring && navButton("insert_chart", "scores", `/${cuid}/scores`, "Call Scores")}
    </div>
  );
};

CallDetailsNavColumn.propTypes = {
  cuid: PropTypes.string,
  currentPane: PropTypes.oneOf(["calls", "comments", "scores"]).isRequired,
  enableCallCommenting: PropTypes.bool,
  enableCallScoring: PropTypes.bool,
  transcriptPresent: PropTypes.bool,
  transcriptExpanded: PropTypes.bool.isRequired,
  onTranscriptExpandedChange: PropTypes.func.isRequired
};

CallDetailsNavColumn.defaultProps = {
  cuid: "",
  enableCallCommenting: false,
  enableCallScoring: false,
  transcriptPresent: false
};

export default CallDetailsNavColumn;
